import {
    WHITEBOARD_COMPONENT_ADD,
    WHITEBOARD_COMPONENT_ARRANGE,
    WHITEBOARD_COMPONENT_COPY,
    WHITEBOARD_COMPONENT_MUTATE,
    WHITEBOARD_COMPONENT_PASTE,
    WHITEBOARD_COMPONENT_REMOVE,
    WHITEBOARD_COMPONENT_SET_ID,
    WHITEBOARD_COMPONENTS_REFRESH,
    WHITEBOARD_COMPONENTS_REFRESH_COMPLETED,
} from "constants/action-types";
import { Map } from "immutable";
import { EventTypes } from "redux-segment";

export const create = (type: string, props: any, select = true) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: {
        props,
        select,
        type,
    },
    type: WHITEBOARD_COMPONENT_ADD,
});

export const remove = (id: string) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: id,
    type: WHITEBOARD_COMPONENT_REMOVE,
});

export const mutate = (component: any, propsOrKey: any, value?, whiteboard?) => ({
    payload: { component, propsOrKey, value, whiteboard },
    type: WHITEBOARD_COMPONENT_MUTATE,
});

export const arrange = (id: string, relativePosition: number) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { id, relativePosition },
    type: WHITEBOARD_COMPONENT_ARRANGE,
});

export const copy = (component: Map<string, any>) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { component },
    type: WHITEBOARD_COMPONENT_COPY,
});

export const paste = (component?) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { component },
    type: WHITEBOARD_COMPONENT_PASTE,
});

export const current = {
    set: (id: string | null) => ({
        payload: id,
        type: WHITEBOARD_COMPONENT_SET_ID,
    }),
};

export const refreshLabels = (ids, components) => ({
    payload: {
        components,
        ids,
    },
    type: WHITEBOARD_COMPONENTS_REFRESH,
});

export const refreshLabelsCompleted = () => ({ type: WHITEBOARD_COMPONENTS_REFRESH_COMPLETED });
